import { RefObject } from 'react';

import { PAYPAL_BUTTON_SETTINGS } from '../constants';
import { IPayPal, IPayPalButtonActions } from '../model';

declare const paypal: IPayPal;

interface IInitializeButtonsProps extends IPayPalButtonActions {
  containerRef: RefObject<HTMLDivElement>;
}

export const initializeButtons = ({ containerRef, ...buttonProps }: IInitializeButtonsProps) => {
  if (!paypal?.Buttons) {
    return;
  }
  paypal
    .Buttons({
      style: PAYPAL_BUTTON_SETTINGS,
      ...buttonProps,
    })
    .render(containerRef.current);
};
